<div class="home-container">
  <div class="body-container">
    <h3>User profile</h3>
    <br />
    <p>You are logged in as user: {{ username$ | async }}</p>
    <button class="btn btn-primary" (click)="logout()">Logout</button>
  </div>
</div>
